import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../assets/blast-logo.webp';

const GEAR_WAJIB = [
  { icon: 'fa-solid fa-helmet-safety', title: 'Helm SNI/DOT', desc: 'Wajib pas di kepala, kunci strap terkancing rapat. Helm setengah tetep mending drpd gak pake, tapi full-face paling aman.' },
  { icon: 'fa-solid fa-shirt', title: 'Jaket Riding', desc: 'Lengan panjang, idealnya ada protector di siku & bahu. Jaket biasa juga OK drpd kaos tipis doang.' },
  { icon: 'fa-solid fa-mitten', title: 'Sarung Tangan', desc: 'Lindungin tangan pas jatuh (refleks pertama nahan pake tangan). Pilih yang griprnya bagus buat pegang setang.' },
  { icon: 'fa-solid fa-socks', title: 'Celana Panjang', desc: 'Bukan celana pendek/sarung. Bahan tebal (jeans/riding pants) ngelindungin kulit dari aspal kalau jatuh.' },
  { icon: 'fa-solid fa-shoe-prints', title: 'Sepatu Tertutup', desc: 'Nutup mata kaki. Sandal jepit = gak ada perlindungan sama sekali buat kaki & jari.' },
];

const CEK_MOTOR = [
  { icon: 'fa-solid fa-circle-dot', title: 'Ban', desc: 'Cek tekanan angin & kembangan. Ban gundul = gampang selip, apalagi pas ujan.' },
  { icon: 'fa-solid fa-hand', title: 'Rem', desc: 'Tes rem depan-belakang sebelum jalan. Rem blong itu paling bahaya.' },
  { icon: 'fa-solid fa-oil-can', title: 'Oli', desc: 'Cek volume & warna oli mesin. Jangan sampe telat ganti, mesin bisa rusak di jalan.' },
  { icon: 'fa-solid fa-lightbulb', title: 'Lampu & Sein', desc: 'Depan, belakang, sein kanan-kiri semua nyala. Penting banget buat touring malem.' },
  { icon: 'fa-solid fa-car-battery', title: 'Aki', desc: 'Aki lemah bikin starter susah & lampu redup. Cek terutama kalau motor jarang dipake.' },
  { icon: 'fa-solid fa-gas-pump', title: 'BBM', desc: 'Isi penuh sebelum berangkat, apalagi kalau rutenya jarang ada SPBU.' },
];

const ATURAN_EMAS = [
  { good: true, text: 'Jaga jarak aman minimal 2-3 detik dari motor di depan' },
  { good: true, text: 'Cek spion sebelum belok atau pindah jalur' },
  { good: true, text: 'Nyalain lampu sein jauh-jauh hari sebelum belok' },
  { good: true, text: 'Kurangin kecepatan di tikungan & jalan basah' },
  { good: false, text: 'Zig-zag nyalip dari kiri-kanan gantian' },
  { good: false, text: 'Main HP atau lepas tangan pas jalan' },
  { good: false, text: 'Ngebut ngejar rombongan yang udah jauh di depan' },
  { good: false, text: 'Boncengan lebih dari kapasitas motor' },
];

export default function SafetyRiding() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      <nav style={{ padding: '18px 6vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/"><img src={logoImg} alt="Blast Motor Club" style={{ height: 36, width: 'auto' }} /></Link>
        <Link to="/" style={{ color: '#D02127', fontSize: 13, textDecoration: 'none' }}>← Beranda</Link>
      </nav>

      {/* HERO */}
      <section style={{
        padding: '20px 6vw 50px', textAlign: 'center',
        background: 'linear-gradient(160deg, #1C2128 0%, #12151A 100%)',
      }}>
        <div style={{
          width: 90, height: 90, borderRadius: '50%', background: 'rgba(208,33,39,0.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 40, color: '#D02127',
        }}>
          <i className="fa-solid fa-motorcycle"></i>
        </div>
        <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          Safety Riding
        </span>
        <h1 style={{ fontSize: 'clamp(28px, 6vw, 48px)', fontWeight: 900, fontStyle: 'italic', margin: '10px 0 16px' }}>
          Pulang Selamat Itu Nomor Satu
        </h1>
        <p style={{ color: '#8B92A0', fontSize: 15, maxWidth: 500, margin: '0 auto', lineHeight: 1.7 }}>
          Touring seru itu penting, tapi sampai rumah dengan selamat jauh lebih penting. Ini panduan lengkap biar setiap perjalanan Blast Motor Club aman buat semua.
        </p>
      </section>

      <div style={{ padding: '0 6vw 80px', maxWidth: 900, margin: '0 auto' }}>

        {/* KELENGKAPAN WAJIB */}
        <section style={{ marginTop: 50 }}>
          <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>01 · Kelengkapan</span>
          <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 32px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 6px' }}>
            5 Perlengkapan Wajib
          </h2>
          <p style={{ color: '#8B92A0', fontSize: 14, marginBottom: 24 }}>
            Sebelum starter motor, pastiin 5 ini udah nempel di badan. Bukan buat gaya-gayaan, tapi ini yang nyelametin kalau ada apa-apa.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
            {GEAR_WAJIB.map((g, i) => (
              <div key={i} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 12, padding: 20 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 10, background: 'rgba(43,105,150,0.15)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, color: '#2B6996', marginBottom: 14,
                }}>
                  <i className={g.icon}></i>
                </div>
                <p style={{ fontWeight: 800, fontSize: 15, marginBottom: 6 }}>{g.title}</p>
                <p style={{ color: '#8B92A0', fontSize: 12.5, lineHeight: 1.6 }}>{g.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CEK MOTOR */}
        <section style={{ marginTop: 56 }}>
          <span style={{ color: '#2B6996', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>02 · Persiapan</span>
          <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 32px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 6px' }}>
            Cek Motor Sebelum Berangkat
          </h2>
          <p style={{ color: '#8B92A0', fontSize: 14, marginBottom: 24 }}>
            5 menit ngecek ini bisa nyelametin touring kalian dari mogok atau kecelakaan di tengah jalan.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
            {CEK_MOTOR.map((c, i) => (
              <div key={i} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 12, padding: 20 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 10, background: 'rgba(208,33,39,0.15)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, color: '#D02127', marginBottom: 14,
                }}>
                  <i className={c.icon}></i>
                </div>
                <p style={{ fontWeight: 800, fontSize: 15, marginBottom: 6 }}>{c.title}</p>
                <p style={{ color: '#8B92A0', fontSize: 12.5, lineHeight: 1.6 }}>{c.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* FORMASI TOURING */}
        <section style={{ marginTop: 56 }}>
          <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>03 · Touring Bareng</span>
          <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 32px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 6px' }}>
            Formasi & Etika Rombongan
          </h2>
          <p style={{ color: '#8B92A0', fontSize: 14, marginBottom: 24 }}>
            Touring rame-rame butuh disiplin bareng. Ini yang bikin rombongan tetep rapi dan gak ada yang keteteran.
          </p>

          <div style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 12, padding: 24, marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', marginBottom: 18 }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(208,33,39,0.15)', color: '#D02127', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, flexShrink: 0 }}>1</div>
              <div>
                <p style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>Leader di Depan, Sweeper di Belakang</p>
                <p style={{ color: '#8B92A0', fontSize: 13, lineHeight: 1.6 }}>Leader nentuin kecepatan & rute, sweeper mastiin gak ada yang ketinggalan di paling belakang. Jangan ada yang motong jadi paling depan tanpa komunikasi.</p>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', marginBottom: 18 }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(208,33,39,0.15)', color: '#D02127', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, flexShrink: 0 }}>2</div>
              <div>
                <p style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>Formasi Zig-Zag (Selang-Seling)</p>
                <p style={{ color: '#8B92A0', fontSize: 13, lineHeight: 1.6 }}>Posisi motor selang-seling kiri-kanan (bukan sejajar), biar tiap orang punya jarak pandang & ruang ngerem yang cukup.</p>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(208,33,39,0.15)', color: '#D02127', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, flexShrink: 0 }}>3</div>
              <div>
                <p style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>Kode Tangan Antar Pengendara</p>
                <p style={{ color: '#8B92A0', fontSize: 13, lineHeight: 1.6 }}>Tangan nunjuk ke bawah = ada lubang/polisi tidur. Tangan ngepal diangkat = rombongan berhenti. Lambaian pelan = pelan-pelan/hati-hati di depan. Kasih tau ke belakang biar semua siap.</p>
              </div>
            </div>
          </div>
        </section>

        {/* ATURAN EMAS - DO/DONT */}
        <section style={{ marginTop: 56 }}>
          <span style={{ color: '#2B6996', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>04 · Di Jalan</span>
          <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 32px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 6px' }}>
            Aturan Emas Berkendara
          </h2>
          <p style={{ color: '#8B92A0', fontSize: 14, marginBottom: 24 }}>
            Kebiasaan simpel yang bedain riding santai vs riding yang beresiko.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {ATURAN_EMAS.map((a, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: 12, background: '#1C2128',
                border: `1px solid ${a.good ? 'rgba(74,222,128,0.3)' : 'rgba(208,33,39,0.3)'}`,
                borderRadius: 10, padding: '12px 16px',
              }}>
                <span style={{
                  width: 24, height: 24, borderRadius: '50%', flexShrink: 0,
                  background: a.good ? 'rgba(74,222,128,0.15)' : 'rgba(208,33,39,0.15)',
                  color: a.good ? '#4ADE80' : '#D02127',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12,
                }}>
                  <i className={a.good ? 'fa-solid fa-check' : 'fa-solid fa-xmark'}></i>
                </span>
                <p style={{ fontSize: 13.5, color: '#F0EDE4' }}>{a.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* KONDISI HUJAN */}
        <section style={{ marginTop: 56 }}>
          <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>05 · Kondisi Ekstrem</span>
          <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 32px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 6px' }}>
            Riding Pas Hujan
          </h2>
          <div style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 12, padding: 24 }}>
            <div style={{ display: 'flex', gap: 20, alignItems: 'center', marginBottom: 16 }}>
              <div style={{ fontSize: 32, color: '#2B6996' }}><i className="fa-solid fa-cloud-rain"></i></div>
              <p style={{ color: '#8B92A0', fontSize: 13.5, lineHeight: 1.7 }}>
                Jalan basah bikin jarak pengereman 2x lebih panjang. Marka jalan & manhole/besi jadi super licin. Kurangin kecepatan, jaga jarak lebih jauh dari biasanya, dan hindari genangan yang dalemnya gak keliatan.
              </p>
            </div>
            <ul style={{ color: '#8B92A0', fontSize: 13, lineHeight: 2, paddingLeft: 20, margin: 0 }}>
              <li>Pakai jas hujan model setelan (bukan ponco), biar gak nutupin pandangan atau nyangkut di ban</li>
              <li>Nyalain lampu utama biar keliatan sama kendaraan lain, walau siang hari</li>
              <li>Kalau hujan deras banget & jarak pandang jelek, mending berteduh dulu drpd maksa jalan</li>
            </ul>
          </div>
        </section>

        {/* EMERGENCY */}
        <section style={{ marginTop: 56 }}>
          <span style={{ color: '#2B6996', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>06 · Darurat</span>
          <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 32px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 6px' }}>
            Kalau Ada Kejadian di Jalan
          </h2>
          <div style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 12, padding: 24 }}>
            <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', marginBottom: 16 }}>
              <div style={{ fontSize: 24, color: '#D02127', flexShrink: 0 }}><i className="fa-solid fa-kit-medical"></i></div>
              <p style={{ color: '#8B92A0', fontSize: 13.5, lineHeight: 1.7 }}>
                Kalau ada member jatuh/kecelakaan: <b style={{ color: '#F0EDE4' }}>amankan dulu posisi</b> (motor & korban minggir dari jalur kendaraan lain), <b style={{ color: '#F0EDE4' }}>jangan buru-buru lepas helm</b> korban kalau curiga cedera leher/kepala, dan segera hubungi kontak darurat yang udah didaftarin di profil member.
              </p>
            </div>
            <p style={{ color: '#5a616e', fontSize: 12, lineHeight: 1.6 }}>
              Setiap member Blast udah punya kontak darurat tersimpan di profil (cuma keliatan sama Ketua/Wapil Ketua/Pengurus) — pastiin data kontak kalian selalu update lewat halaman Edit Profil.
            </p>
          </div>
        </section>

        {/* CTA */}
        <section style={{ marginTop: 56, textAlign: 'center', background: '#1C2128', border: '1px solid #262b33', borderRadius: 16, padding: '36px 24px' }}>
          <p style={{ fontSize: 18, fontWeight: 800, fontStyle: 'italic', marginBottom: 8 }}>Udah siap touring dengan aman?</p>
          <p style={{ color: '#8B92A0', fontSize: 13, marginBottom: 20 }}>Cek jadwal touring terdekat dan gabung bareng member lain.</p>
          <Link to="/history" style={{
            display: 'inline-block', background: '#D02127', color: '#fff', padding: '12px 28px',
            borderRadius: 8, fontWeight: 700, fontSize: 14, textDecoration: 'none',
          }}>
            Lihat Jadwal Touring →
          </Link>
        </section>
      </div>

      <footer style={{ padding: '32px 6vw', borderTop: '1px solid #262b33', textAlign: 'center', color: '#5a616e', fontSize: 12 }}>
        © 2026 Blast Motor Club · <Link to="/privacy" style={{ color: '#5a616e' }}>Kebijakan Privasi</Link>
      </footer>
    </div>
  );
}
